import React, { useEffect, useState } from 'react'
import { feeSettingFormFields, feeTypeOptionList, feeModelOptionList, feeModelOptionListForPercentage } from './constant'
import { Link, withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import _, { get } from 'lodash'
import BreadCrumb from '../../../components/BreadCrumb';
import { handleError, handleFieldError, initializeForm } from '../../../utils/form-validation';
import SelectNew from '../../../components/FormElements/SelectNew'
import routes from '../../../routes';
import ToastModal from "../../../components/ToastModal";
import { getListbyIdFeeSettingAction, postGetbyIdFeeSettingAction, postUpdateFeeSettingAction } from '../../../actions';
import moment from 'moment';
import { defaultPlatformConfig } from '../../../constants/configuration';
import { getDateFromUtcToSpecificZone, getTenantTimeZone } from '../../../selectors';
const Card = asyncRoute(() => import('../../../components/Card'));
const Input = asyncRoute(() => import('../../../components/FormElements/Input'))

function AddFeeSetting(props) {

    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const [tenantListData, setTenantListData] = useState([])
    const [listByData, setListByData] = useState([])
    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });
    const [strageyOptionList, setStrageyOptionList] = useState([])
    const [formFields, setFormFields] = useState(feeSettingFormFields);
    const [isViewFeeSetting, setIsViewFeeSetting] = useState(props.location.pathname.includes(routes.feeSettings.viewFeeSettings));

    const tenantId = useSelector((state) => get(state, 'app.preSignInState.tenantId', ''));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const platformConfiguration = useSelector(state => get(state, 'app.platformConfiguration', {}));
    const dispatch = useDispatch();


    useEffect(() => {
        let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        const tenantList = Object.keys(preSignInData).length > 0 && preSignInData.hasOwnProperty('responseList') && preSignInData.responseList
        setTenantListData(tenantList);
        setPlatformNameInFormfields();
        formInitialize(tenantList);

    }, [])

    const setPlatformNameInFormfields = () => {
        const updatedFormFields = { ...formFields };
        let platformName = platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name'];
        _.each(_.keys(updatedFormFields), function (key) {
            if (updatedFormFields[key]['containsPlatformName']) {
                updatedFormFields[key]['label'] = updatedFormFields[key]['label'].replace(/beki/gi, platformName);
            }
        });
        setTimeout(() => {
            setFormFields(updatedFormFields);
        }, 300);
    };

    const formInitialize = async (tenantList) => {
        const { match: { params: { id } } } = props;
        let { form, errors } = initializeForm(formFields);
        const isAgency = tenantList.find(data => data.tenantId == tenantId)

        const payload = {
            filter: {
                campaignId: [id],
                // advId:[]
            }

        }

        await dispatch(postGetbyIdFeeSettingAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    const responseData = response[0]
                    // setForm Data
                    const updatedFormFields = _.cloneDeep(formFields);
                    if (Object.keys(isAgency).length > 0 && isAgency.hasOwnProperty('tenantType')) {
                        if (isAgency.tenantType == "Platform Manager" && responseData.marginDetails && responseData.marginDetails.length > 0 && responseData.marginDetails[0].tpBid 
                            // && responseData.marginDetails[0].tpBudget
                        ) {
                            form.feeModel = responseData.feeModel
                            form.feeValue = responseData.feeValue
                            form.strategyName = responseData.marginDetails[0].strategyId
                            form.bekiBuyingBidMarginValue = responseData.marginDetails[0].atdBid
                            form.agencyBuyingBidMarginValue = responseData.marginDetails[0].agencyBid
                            form.platformBuyingBidMarginValue = responseData.marginDetails[0].tpBid
                            form.bekiBudgetMarginValue = responseData.marginDetails[0].atdBudget
                            form.agencyBudgetMarginValue = responseData.marginDetails[0].agencyBudget
                            form.platfromBudgetMarginValue = responseData.marginDetails[0].tpBudget ? responseData.marginDetails[0].tpBudget : ''
                            form.fixedNewBuyingBidValue = responseData.feeModel == 3 ? '' : responseData.marginDetails[0].tpBid

                            if (responseData.feeModel == 3) {
                                updatedFormFields.strategyName.required = true
                                updatedFormFields.percentageBekiBuyingBidValue.required = false
                                updatedFormFields.percentagePlatformBuyingBidValue.required = false
                                updatedFormFields.percentageBekiBudgetValue.required = false
                                updatedFormFields.percentagePlatfromBudgetValue.required = false
                                updatedFormFields.fixedNewBuyingBidValue.required = false

                                updatedFormFields.bekiBuyingBidMarginValue.required = true
                                updatedFormFields.agencyBuyingBidMarginValue.required = true
                                updatedFormFields.platformBuyingBidMarginValue.required = true
                                updatedFormFields.bekiBudgetMarginValue.required = true
                                updatedFormFields.agencyBudgetMarginValue.required = true
                                updatedFormFields.platfromBudgetMarginValue.required = true

                            } else {
                                updatedFormFields.strategyName.required = false
                                updatedFormFields.bekiBuyingBidMarginValue.required = false
                                updatedFormFields.agencyBuyingBidMarginValue.required = false
                                updatedFormFields.platformBuyingBidMarginValue.required = false
                                updatedFormFields.bekiBudgetMarginValue.required = false
                                updatedFormFields.agencyBudgetMarginValue.required = false
                                updatedFormFields.platfromBudgetMarginValue.required = false
                                updatedFormFields.percentageBekiBuyingBidValue.required = false
                                updatedFormFields.percentagePlatformBuyingBidValue.required = false
                                updatedFormFields.percentageBekiBudgetValue.required = false
                                updatedFormFields.percentagePlatfromBudgetValue.required = false
                                updatedFormFields.fixedNewBuyingBidValue.required = true
                                form.agencyBuyingBidMarginValue = (responseData.marginDetails[0].atdBid - responseData.secondaryFeeValue * responseData.marginDetails[0].atdBid / 100).toFixed(2);
                                form.agencyBudgetMarginValue = (responseData.marginDetails[0].atdBudget - responseData.secondaryFeeValue * responseData.marginDetails[0].atdBudget / 100).toFixed(2);
                            }

                        } else if (isAgency.tenantType != "Advertiser") {
                            form.feeModel = responseData.feeModel
                            form.feeValue = responseData.feeValue
                            form.strategyName = responseData.marginDetails[0].strategyId
                            form.percentageBekiBuyingBidValue = responseData.marginDetails[0].atdBid
                            form.percentagePlatformBuyingBidValue = responseData.marginDetails[0].agencyBid
                            form.percentageBekiBudgetValue = responseData.marginDetails[0].atdBudget
                            form.percentagePlatfromBudgetValue = responseData.marginDetails[0].agencyBudget
                            form.fixedNewBuyingBidValue = responseData.feeModel == 3 ? '' : responseData.marginDetails[0].tpBid

                            if (responseData.feeModel == 3) {
                                updatedFormFields.strategyName.required = true
                                updatedFormFields.bekiBuyingBidMarginValue.required = false
                                updatedFormFields.agencyBuyingBidMarginValue.required = false
                                updatedFormFields.platformBuyingBidMarginValue.required = false
                                updatedFormFields.bekiBudgetMarginValue.required = false
                                updatedFormFields.agencyBudgetMarginValue.required = false
                                updatedFormFields.platfromBudgetMarginValue.required = false
                                updatedFormFields.fixedNewBuyingBidValue.required = false

                                updatedFormFields.percentageBekiBuyingBidValue.required = true
                                updatedFormFields.percentagePlatformBuyingBidValue.required = true
                                updatedFormFields.percentageBekiBudgetValue.required = true
                                updatedFormFields.percentagePlatfromBudgetValue.required = true

                            } else {
                                updatedFormFields.strategyName.required = false
                                updatedFormFields.bekiBuyingBidMarginValue.required = false
                                updatedFormFields.agencyBuyingBidMarginValue.required = false
                                updatedFormFields.platformBuyingBidMarginValue.required = false
                                updatedFormFields.bekiBudgetMarginValue.required = false
                                updatedFormFields.agencyBudgetMarginValue.required = false
                                updatedFormFields.platfromBudgetMarginValue.required = false
                                updatedFormFields.percentageBekiBuyingBidValue.required = false
                                updatedFormFields.percentagePlatformBuyingBidValue.required = false
                                updatedFormFields.percentageBekiBudgetValue.required = false
                                updatedFormFields.percentagePlatfromBudgetValue.required = false
                                updatedFormFields.fixedNewBuyingBidValue.required = true
                            }

                        }

                    }

                    // End here data set


                    const List = response[0].marginDetails.map((ele) => {
                        return {
                            id: ele.strategyId, value: ele.strategyName
                        }
                    })
                    setStrageyOptionList(List)
                    setListByData(response);
                    setTimeout(() => {
                        setFormFields(updatedFormFields);
                    }, 300);
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setForm(form)
    };




    const disabledFormFields = (currentValue) => {
        var isAgency = {}
        if (tenantListData && tenantListData.length > 0) {
            isAgency = tenantListData.find(data => data.tenantId == tenantId)
        }
        const updatedFormFields = _.cloneDeep(formFields);

        if (Object.keys(isAgency).length > 0 && isAgency.hasOwnProperty('tenantType')) {
            if (isAgency.tenantType == "Platform Manager" && listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0 && listByData[0].marginDetails[0].tpBid 
                // && listByData[0].marginDetails[0].tpBudget
            ) {

                if (currentValue == '3') {
                    updatedFormFields.strategyName.required = true
                    updatedFormFields.percentageBekiBuyingBidValue.required = false
                    updatedFormFields.percentagePlatformBuyingBidValue.required = false
                    updatedFormFields.percentageBekiBudgetValue.required = false
                    updatedFormFields.percentagePlatfromBudgetValue.required = false
                    updatedFormFields.fixedNewBuyingBidValue.required = false

                    updatedFormFields.bekiBuyingBidMarginValue.required = true
                    updatedFormFields.agencyBuyingBidMarginValue.required = true
                    updatedFormFields.platformBuyingBidMarginValue.required = true
                    updatedFormFields.bekiBudgetMarginValue.required = true
                    updatedFormFields.agencyBudgetMarginValue.required = true
                    updatedFormFields.platfromBudgetMarginValue.required = true
                } else {
                    updatedFormFields.strategyName.required = false
                    updatedFormFields.bekiBuyingBidMarginValue.required = false
                    updatedFormFields.agencyBuyingBidMarginValue.required = false
                    updatedFormFields.platformBuyingBidMarginValue.required = false
                    updatedFormFields.bekiBudgetMarginValue.required = false
                    updatedFormFields.agencyBudgetMarginValue.required = false
                    updatedFormFields.platfromBudgetMarginValue.required = false
                    updatedFormFields.percentageBekiBuyingBidValue.required = false
                    updatedFormFields.percentagePlatformBuyingBidValue.required = false
                    updatedFormFields.percentageBekiBudgetValue.required = false
                    updatedFormFields.percentagePlatfromBudgetValue.required = false
                    updatedFormFields.fixedNewBuyingBidValue.required = true

                }

            } else if (isAgency.tenantType != "Advertiser") {

                if (currentValue == '3') {
                    updatedFormFields.strategyName.required = true
                    updatedFormFields.bekiBuyingBidMarginValue.required = false
                    updatedFormFields.agencyBuyingBidMarginValue.required = false
                    updatedFormFields.platformBuyingBidMarginValue.required = false
                    updatedFormFields.bekiBudgetMarginValue.required = false
                    updatedFormFields.agencyBudgetMarginValue.required = false
                    updatedFormFields.platfromBudgetMarginValue.required = false
                    updatedFormFields.fixedNewBuyingBidValue.required = false

                    updatedFormFields.percentageBekiBuyingBidValue.required = true
                    updatedFormFields.percentagePlatformBuyingBidValue.required = true
                    updatedFormFields.percentageBekiBudgetValue.required = true
                    updatedFormFields.percentagePlatfromBudgetValue.required = true
                } else {
                    updatedFormFields.strategyName.required = false
                    updatedFormFields.bekiBuyingBidMarginValue.required = false
                    updatedFormFields.agencyBuyingBidMarginValue.required = false
                    updatedFormFields.platformBuyingBidMarginValue.required = false
                    updatedFormFields.bekiBudgetMarginValue.required = false
                    updatedFormFields.agencyBudgetMarginValue.required = false
                    updatedFormFields.platfromBudgetMarginValue.required = false

                    updatedFormFields.percentageBekiBuyingBidValue.required = false
                    updatedFormFields.percentagePlatformBuyingBidValue.required = false
                    updatedFormFields.percentageBekiBudgetValue.required = false
                    updatedFormFields.percentagePlatfromBudgetValue.required = false
                    updatedFormFields.fixedNewBuyingBidValue.required = true
                }

            }


        }
        setFormFields(updatedFormFields);
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        if (name == formFields.feeModel.key) {
            const resFeeValue = listByData && listByData.length > 0 && listByData[0].feeValue
            disabledFormFields(value);
            newForm[formFields.percentagePlatformBuyingBidValue.key] = recalculatedValue(resFeeValue).PltBuyingBidValue;
            newForm[formFields.percentagePlatfromBudgetValue.key] = recalculatedValue(resFeeValue).PltBuyingBudgetValue;

            newForm[formFields.platformBuyingBidMarginValue.key] = recalculatedValue(resFeeValue).PltBuyingBidValue;
            newForm[formFields.platfromBudgetMarginValue.key] = recalculatedValue(resFeeValue).PltBuyingBudgetValue;
        }

        if (name == formFields.feeValue.key) {
            newForm[formFields.percentagePlatformBuyingBidValue.key] = recalculatedValue(value).PltBuyingBidValue;
            newForm[formFields.percentagePlatfromBudgetValue.key] = recalculatedValue(value).PltBuyingBudgetValue;

            newForm[formFields.platformBuyingBidMarginValue.key] = recalculatedValue(value).PltBuyingBidValue;
            newForm[formFields.platfromBudgetMarginValue.key] = recalculatedValue(value).PltBuyingBudgetValue;
        }

        if (name == formFields.strategyName.key) {
            newForm[formFields.feeValue.key] = listByData && listByData.length > 0 && listByData[0].feeValue
            const isAgency = tenantListData.find(data => data.tenantId == tenantId)
            if (isAgency.tenantType == "Platform Manager" && listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0 && listByData[0].marginDetails[0].tpBid && listByData[0].marginDetails[0].tpBudget) {
                newForm[formFields.bekiBuyingBidMarginValue.key] = strategyCalcluation(value).bekiBuyingBidValue;
                newForm[formFields.bekiBudgetMarginValue.key] = strategyCalcluation(value).bekiBudgetValue;
                newForm[formFields.agencyBuyingBidMarginValue.key] = strategyCalcluation(value).agencyBuyingBidValue;
                newForm[formFields.agencyBudgetMarginValue.key] = strategyCalcluation(value).agencyBudgetValue;
                newForm[formFields.platformBuyingBidMarginValue.key] = strategyCalcluation(value).platformBuyingBidValue;
                newForm[formFields.platfromBudgetMarginValue.key] = strategyCalcluation(value).platfromBudgetValue;
            } else if (isAgency.tenantType != "Advertiser") {
                newForm[formFields.percentageBekiBuyingBidValue.key] = strategyCalcluation(value).bekiBuyingBidValue;
                newForm[formFields.percentageBekiBudgetValue.key] = strategyCalcluation(value).bekiBudgetValue;
                newForm[formFields.percentagePlatformBuyingBidValue.key] = strategyCalcluation(value).platformBuyingBidValue;
                newForm[formFields.percentagePlatfromBudgetValue.key] = strategyCalcluation(value).platfromBudgetValue;

            }
        }
        setForm((prevForm) => ({ ...prevForm, ...newForm }));
    };

    const strategyCalcluation = (value) => {
        const isAgency = tenantListData.find(data => data.tenantId == tenantId)
        if (listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0) {
            const selectedStragegy = listByData[0].marginDetails.find((ele) => ele.strategyId == value)
            if (isAgency.tenantType == "Platform Manager" && listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0 && listByData[0].marginDetails[0].tpBid && listByData[0].marginDetails[0].tpBudget) {

                const bekiBuyingBidValue = selectedStragegy.atdBid
                const bekiBudgetValue = selectedStragegy.atdBudget
                const platformBuyingBidValue = selectedStragegy.tpBid
                const platfromBudgetValue = selectedStragegy.tpBudget
                const agencyBuyingBidValue = selectedStragegy.agencyBid
                const agencyBudgetValue = selectedStragegy.agencyBudget

                const obj = {
                    bekiBuyingBidValue: bekiBuyingBidValue.toFixed(2),
                    bekiBudgetValue: bekiBudgetValue.toFixed(2),
                    platformBuyingBidValue: platformBuyingBidValue.toFixed(2),
                    platfromBudgetValue: platfromBudgetValue.toFixed(2),
                    agencyBuyingBidValue: agencyBuyingBidValue.toFixed(2),
                    agencyBudgetValue: agencyBudgetValue.toFixed(2)
                }
                return obj;



            } else if (isAgency.tenantType != "Advertiser") {
                const bekiBuyingBidValue = selectedStragegy.atdBid
                const bekiBudgetValue = selectedStragegy.atdBudget
                const platformBuyingBidValue = selectedStragegy.agencyBid
                const platfromBudgetValue = selectedStragegy.agencyBudget

                const obj = {
                    bekiBuyingBidValue: bekiBuyingBidValue.toFixed(2),
                    bekiBudgetValue: bekiBudgetValue.toFixed(2),
                    platformBuyingBidValue: platformBuyingBidValue.toFixed(2),
                    platfromBudgetValue: platfromBudgetValue.toFixed(2)
                }
                return obj;

            }

        }
    }


    const recalculatedValue = (currentFeeValue) => {
        const isAgency = tenantListData.find(data => data.tenantId == tenantId)
        if (Object.keys(isAgency).length > 0 && isAgency.hasOwnProperty('tenantType')) {
            if (isAgency.tenantType == "Platform Manager" && listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0 && listByData[0].marginDetails[0].tpBid 
                // && listByData[0].marginDetails[0].tpBudget
            ) {

                const PltBuyingBidValue = form.agencyBuyingBidMarginValue - currentFeeValue * form.agencyBuyingBidMarginValue / 100;
                const PltBuyingBudgetValue = form.agencyBudgetMarginValue - currentFeeValue * form.agencyBudgetMarginValue / 100;

                const obj = {
                    PltBuyingBidValue: PltBuyingBidValue.toFixed(2),
                    PltBuyingBudgetValue: PltBuyingBudgetValue.toFixed(2)
                }

                return obj;



            } else if (isAgency.tenantType != "Advertiser") {
                const PltBuyingBidValue = form.percentageBekiBuyingBidValue - currentFeeValue * form.percentageBekiBuyingBidValue / 100;
                const PltBuyingBudgetValue = form.percentageBekiBudgetValue - currentFeeValue * form.percentageBekiBudgetValue / 100;

                const obj = {
                    PltBuyingBidValue: PltBuyingBidValue.toFixed(2),
                    PltBuyingBudgetValue: PltBuyingBudgetValue.toFixed(2)
                }

                return obj;


            }

        }
    }


    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const showConfirmation = () => {

        let { errors, valid } = handleError(form, formFields);
        if (valid) {
            let confirmationMessage = "Kindly let us know if you'd like to save your changes.";
            toast('confirmation', confirmationMessage);
        }
        setSubmited(true);
        setErrors(errors);
    };
    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });
        handleSubmit();
    };

    const handleSubmit = async () => {
        const isAgency = tenantListData.find(data => data.tenantId == tenantId)
        const { match: { params: { id } } } = props;
        const listbyIdResponse = listByData[0]
        var payload = {}

        if (form.feeModel == 3) {
            if (isAgency.tenantType == "Platform Manager" && listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0 && listByData[0].marginDetails[0].tpBid && listByData[0].marginDetails[0].tpBudget) {
                const marginDetailsArray = listByData[0].marginDetails.map((ele) => {
                    return {
                        id: ele.id,
                        campaignId: ele.campaignId,
                        strategyName: ele.strategyName,
                        margin: ele.margin,
                        marginType: ele.marginType,
                        marginModel: ele.marginModel,
                        atdBid: ele.atdBid,
                        atdBudget: ele.atdBudget,
                        agencyBid: ele.agencyBid,
                        agencyBudget: ele.agencyBudget,
                        tpBid: +form.platformBuyingBidMarginValue,
                        tpBudget: +form.platfromBudgetMarginValue
                    }
                })
                payload = {
                    feeModel: +form.feeModel,
                    feeValue: +form.feeValue,
                    feeType: form.feeModel == 3 ? 1 : 0,
                    marginDetails: marginDetailsArray
                }

            } else if (isAgency.tenantType != "Advertiser") {

                const marginDetailsArray = listByData[0].marginDetails.map((ele) => {
                    return {
                        id: ele.id,
                        campaignId: ele.campaignId,
                        strategyName: ele.strategyName,
                        margin: ele.margin,
                        marginType: ele.marginType,
                        marginModel: ele.marginModel,
                        atdBid: ele.atdBid,
                        atdBudget: ele.atdBudget,
                        // agencyBid: ele.agencyBid,
                        // agencyBudget: ele.agencyBudget,
                        agencyBid: +form.platformBuyingBidMarginValue,
                        agencyBudget: +form.platfromBudgetMarginValue
                    }
                })


                payload = {
                    feeModel: +form.feeModel,
                    feeValue: +form.feeValue,
                    feeType: form.feeModel == 3 ? 1 : 0,
                    marginDetails: marginDetailsArray
                }
            }
        } else {

            const marginDetailsArray = listByData[0].marginDetails.map((ele) => {
                return {
                    id: ele.id,
                    campaignId: ele.campaignId,
                    strategyName: ele.strategyName,
                    margin: ele.margin,
                    marginType: ele.marginType,
                    marginModel: ele.marginModel,
                    // atdBid: ele.atdBid,
                    // atdBudget: ele.atdBudget,
                    // agencyBid: ele.agencyBid,
                    // agencyBudget: ele.agencyBudget,
                    tpBid: +form.fixedNewBuyingBidValue,
                    // tpBudget: form.platfromBudgetMarginValue
                }
            })
            payload = {
                feeModel: +form.feeModel,
                // feeValue: form.feeValue,
                feeType: form.feeModel == 3 ? 1 : 0,
                marginDetails: marginDetailsArray
            }



        }


        await dispatch(postUpdateFeeSettingAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "", msg = "" },
                    // response,
                } = data;
                if (status === "Success") {
                    toast('Success', msg);

                } else {
                    toast('error', msg);
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });



    }


    var isAgencyOrPlatformManager = {}
    if (tenantListData && tenantListData.length > 0) {
        isAgencyOrPlatformManager = tenantListData.find(data => data.tenantId == tenantId)
    }




    const targetTimeZone = getTenantTimeZone(tenantId);

    return (
        <>
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    path={`${routes.containers.feeSettings}`}
                    poc={false}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    outSideClickEnable={false}
                />
            }
            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <BreadCrumb />
                    <div className={`row mt-3 ${isViewFeeSetting ? 'pe-none' : 'pe-auto'}`}>
                        <Card>
                            <div className='row'>
                                <div className={form.feeModel == 3 ? 'col-md-4' : 'col-md-6'}>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.feeModel.key]}
                                        setting={formFields[formFields.feeModel.key]}
                                        error={errors[formFields.feeModel.key]}
                                        submited={submited}
                                        touched={touched[formFields.feeModel.key]}
                                        options={feeModelOptionList}
                                    />
                                </div>

                                {
                                    form.feeModel == 3 ? <>
                                        <div className='col-md-4'>
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.feeValue.key]}
                                                setting={formFields[formFields.feeValue.key]}
                                                error={errors[formFields.feeValue.key]}
                                                submited={submited}
                                                touched={touched[formFields.feeValue.key]}
                                            />
                                        </div>

                                        <div className='col-md-4'>
                                            <SelectNew
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.strategyName.key]}
                                                setting={formFields[formFields.strategyName.key]}
                                                error={errors[formFields.strategyName.key]}
                                                submited={submited}
                                                touched={touched[formFields.strategyName.key]}
                                                options={strageyOptionList}
                                            />
                                        </div>

                                        {/* Option Screen  */}

                                        {
                                            (Object.keys(isAgencyOrPlatformManager).length > 0 && isAgencyOrPlatformManager.tenantType != "Advertiser") ?
                                                (isAgencyOrPlatformManager.tenantType == "Platform Manager") && (listByData && listByData.length > 0 && listByData[0].marginDetails && listByData[0].marginDetails.length > 0 && listByData[0].marginDetails[0].tpBid 
                                                    // && listByData[0].marginDetails[0].tpBudget
                                                ) ?
                                                    <>

                                                        <div className='col-md-4'>
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.bekiBuyingBidMarginValue.key]}
                                                                setting={formFields[formFields.bekiBuyingBidMarginValue.key]}
                                                                error={errors[formFields.bekiBuyingBidMarginValue.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.bekiBuyingBidMarginValue.key]}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.agencyBuyingBidMarginValue.key]}
                                                                setting={formFields[formFields.agencyBuyingBidMarginValue.key]}
                                                                error={errors[formFields.agencyBuyingBidMarginValue.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.agencyBuyingBidMarginValue.key]}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.platformBuyingBidMarginValue.key]}
                                                                setting={formFields[formFields.platformBuyingBidMarginValue.key]}
                                                                error={errors[formFields.platformBuyingBidMarginValue.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.platformBuyingBidMarginValue.key]}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.bekiBudgetMarginValue.key]}
                                                                setting={formFields[formFields.bekiBudgetMarginValue.key]}
                                                                error={errors[formFields.bekiBudgetMarginValue.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.bekiBudgetMarginValue.key]}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className='col-sm-4'>
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.agencyBudgetMarginValue.key]}
                                                                setting={formFields[formFields.agencyBudgetMarginValue.key]}
                                                                error={errors[formFields.agencyBudgetMarginValue.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.agencyBudgetMarginValue.key]}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.platfromBudgetMarginValue.key]}
                                                                setting={formFields[formFields.platfromBudgetMarginValue.key]}
                                                                error={errors[formFields.platfromBudgetMarginValue.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.platfromBudgetMarginValue.key]}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </> : isAgencyOrPlatformManager.tenantType != "Advertiser" ?
                                                        <>
                                                            <div className='col-md-6'>
                                                                <Input
                                                                    onChange={handleChange}
                                                                    onBlur={handleTouch}
                                                                    value={form[formFields.percentageBekiBuyingBidValue.key]}
                                                                    setting={formFields[formFields.percentageBekiBuyingBidValue.key]}
                                                                    error={errors[formFields.percentageBekiBuyingBidValue.key]}
                                                                    submited={submited}
                                                                    touched={touched[formFields.percentageBekiBuyingBidValue.key]}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <Input
                                                                    onChange={handleChange}
                                                                    onBlur={handleTouch}
                                                                    value={form[formFields.percentagePlatformBuyingBidValue.key]}
                                                                    setting={formFields[formFields.percentagePlatformBuyingBidValue.key]}
                                                                    error={errors[formFields.percentagePlatformBuyingBidValue.key]}
                                                                    submited={submited}
                                                                    touched={touched[formFields.percentagePlatformBuyingBidValue.key]}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <Input
                                                                    onChange={handleChange}
                                                                    onBlur={handleTouch}
                                                                    value={form[formFields.percentageBekiBudgetValue.key]}
                                                                    setting={formFields[formFields.percentageBekiBudgetValue.key]}
                                                                    error={errors[formFields.percentageBekiBudgetValue.key]}
                                                                    submited={submited}
                                                                    touched={touched[formFields.percentageBekiBudgetValue.key]}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <Input
                                                                    onChange={handleChange}
                                                                    onBlur={handleTouch}
                                                                    value={form[formFields.percentagePlatfromBudgetValue.key]}
                                                                    setting={formFields[formFields.percentagePlatfromBudgetValue.key]}
                                                                    error={errors[formFields.percentagePlatfromBudgetValue.key]}
                                                                    submited={submited}
                                                                    touched={touched[formFields.percentagePlatfromBudgetValue.key]}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </> : ''
                                                : ''
                                        }
                                        {/* optional */}

                                    </> : <>
                                        <div className='col-md-6'>
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.fixedNewBuyingBidValue.key]}
                                                setting={formFields[formFields.fixedNewBuyingBidValue.key]}
                                                error={errors[formFields.fixedNewBuyingBidValue.key]}
                                                submited={submited}
                                                touched={touched[formFields.fixedNewBuyingBidValue.key]}
                                            />
                                        </div>
                                    </>

                                }


                            </div>
                            <div className='row text-center mt-4'>
                                {/* <div className='mt-4 suspend'> */}
                                <h6 className='text-danger'><i className="mdi mdi-information" style={{ color: 'red', fontSize: '20px', position: 'relative', top: '3px' }}></i>&nbsp; Please note that the margin specified above is applicable from  {listByData && listByData.length > 0 && listByData[0].modifiedDate && moment(getDateFromUtcToSpecificZone({date:listByData[0].modifiedDate,targetTimeZone:targetTimeZone})).format('YYYY-MM-DD')}</h6>
                                {/* <p className='text-gray'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p> */}
                                {/* </div> */}

                            </div>


                            <div className='row text-center mt-3'>
                                <center>
                                    {
                                        !isViewFeeSetting &&
                                        <button
                                            type="submit"
                                            onClick={() => showConfirmation()}
                                            className="btn btn-primary mr-4"
                                        >
                                            Save
                                        </button>
                                    }
                                    {
                                        !isViewFeeSetting &&
                                        <Link
                                            to={
                                                "/" +
                                                routes.mainRoute +
                                                "/" +
                                                routes.containers.feeSettings
                                            }
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                            >
                                                Cancel
                                            </button>
                                        </Link>
                                    }
                                </center>

                            </div>

                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withRouter(AddFeeSetting)
